import * as React from 'react';

import { localeData } from '../../locales/data';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';

interface ErrorMsgProps {
  errors: any;
}

export const ErrorMsg = ({ errors }: ErrorMsgProps) =>
  errors.size !== 0 ? (
    <div className="error">
      <FormattedMessageHelper tagName="span" id={errors.first()} defaultMessage={localeData.en[errors.first()]} />
    </div>
  ) : null;
